<template>
  <ScrollTopComponent>
      <a class="btn btn-light">
        <img src="../assets/arrow-up.png"/>
      </a>
  </ScrollTopComponent>
</template>

<script>
import ScrollTopComponent from '@/components/ScrollTop'
export default {
  components: {
    ScrollTopComponent
  }
}
</script>

<style>
.btn {
    border-radius: 5px;
    background-color: rgb(182, 40, 40, .7);
    padding-top: 25px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 5px;
}
.btn > img {
  filter: invert(1);
}
</style>